<template>
  <div>
  <a v-if="$parent.info[slg]" class="top-right-align" :href="$parent.info[slg]" target="_blank">
    follow link
  </a>
  <input type="text" autocomplete="off" maxlength="256" class="text-field w-input" :placeholder="fname" v-model="$parent.info[slg]">
</div>
</template>

<script>
export default {
  name: 'Link',
  props: ['slg', 'fname','index'],
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


